import React from 'react';

interface Props {
  liveStream: any,
  isLive: boolean,
  liveStreamTypeIcon: string,
  liveStreamImageUrl: string,
  clickedLiveStream: any,
}

class LiveStreamItem extends React.Component<Props, {}> {
  constructor(props) {
    super(props);
    this.clickedLiveStream = this.clickedLiveStream.bind(this);
  }

  clickedLiveStream(e) {
    this.props.clickedLiveStream(e);
  }

  render() {
    let { liveStream, liveStreamTypeIcon, isLive, liveStreamImageUrl } = this.props;
    let formattedTime = liveStream.formatted_starts_at + " — " + liveStream.formatted_ends_at;
    if(isLive) {
      formattedTime = "LIVE NOW UNTIL " + liveStream.formatted_ends_at;
    }
    return(
      <div className="p2 attendee-live-stream-item-wrapper flexbox-wrapper" onClick={this.clickedLiveStream} data-live-stream-id={liveStream.id}>
        <div className="flexbox-item-small pr2">
          <div className="flexbox-align-center mr2 live-stream-image-box">
            <img src={liveStreamImageUrl} className="img-responsive br4" />
          </div>
        </div>
        <div className="flexbox-item cs-live-blue-alt fw-b">
          <div className="flexbox-item">
            {isLive &&
              <i className="fas fa-video pr1" />
            }
            <i className={`fad ${liveStreamTypeIcon} pr2`} />
            <span>{formattedTime}</span>
          </div>
          <div className="fs-md fw-sb cs-color-black">
            {liveStream.name}
          </div>
        </div>
      </div>
    );
  }
}

export default LiveStreamItem;
